<template>
  <div>
    <AllPropertyList></AllPropertyList>
  </div>
</template>

<script>
import AllPropertyList from "@/components/AllPropertyList";
export default {
  name: "AllProperty",

  components: {
    AllPropertyList,
  },

  data() {
    return {};
  },
};
</script>